import { VueConstructor } from 'vue';
import { DirectiveBinding } from 'vue/types/options';

export default {
  install: (Vue: VueConstructor, options: any) => {
    function inserted(el: HTMLElement, binding: DirectiveBinding) {
      const callback = binding.value;
      const target = binding.arg ? document.querySelector(binding.arg) : window;
      if (!target) return;

      target.addEventListener('scroll', callback, { passive: true });

      (el as any).$onScroll = {
        callback,
        target,
      };
    }

    function unbind(el: HTMLElement) {
      if (!(el as any).$onScroll) return;

      const { callback, target } = (el as any).$onScroll;

      target.removeEventListener('scroll', callback);
      delete (el as any).$onScroll;
    }

    Vue.directive('scroll', { inserted, unbind });
  },
};
